import React from 'react';
import './RefundPolicy.scss';
import Header from '../landing/landing-comp/Header';
import Footer from '../landing/landing-comp/Footer';

const RefundPolicy = () => {
  return (
    <>
    <Header />
    <section className="refund-section">
      <div className="container">
        <div className="header">
          <h2 className="title">Refund Policy</h2>
        </div>
        <p className="content-paragraph">
          All payments made are non refundable and non transferable.
        </p>
        <p className="content-paragraph">
          Use the free access or a trial to test all the features before subscribing to paid plans, 
          as no refund requests will be entertained.
        </p>
      </div>
    </section>
    <Footer />
    </>
  );
};

export default RefundPolicy;